import { render } from "./SearchPalette.vue?vue&type=template&id=69ebf6c6&scoped=true"
import script from "./SearchPalette.vue?vue&type=script&lang=js"
export * from "./SearchPalette.vue?vue&type=script&lang=js"

import "./SearchPalette.vue?vue&type=style&index=0&id=69ebf6c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ebf6c6"]])

export default __exports__